export default "__VITE_ASSET__o7YcvwjM__"